import React from "react";
import { Col, Container, Row } from "react-bootstrap";

import classNames from "classnames";

import CoachButtons from "./CoachButtons";
import CoachView from "./CoachView";
import OpposingCoachView from "./OpposingCoachView";

import { useRosterContext } from "../contexts/Roster";

import { canEditTeam } from "../../../../../lib/utils";

const RosterContent = (): React.JSX.Element => {
    const { currentTeam } = useRosterContext();

    return (
        <Container
            fluid="xs"
            data-testid="rosterContent"
            className="rosterContent"
        >
            <Row>
                <Col>
                    <h2>Current Roster</h2>
                    {currentTeam && canEditTeam(currentTeam) ? (
                        <CoachView />
                    ) : (
                        <OpposingCoachView />
                    )}
                </Col>
            </Row>
            {currentTeam && canEditTeam(currentTeam) && (
                <Row>
                    <Col
                        className={classNames("d-flex", "align-items-baseline")}
                    >
                        <CoachButtons />
                    </Col>
                </Row>
            )}
        </Container>
    );
};

export default RosterContent;
